<script lang="ts">
  import Marquee from '$lib/helpers/Marquee.svelte'
  import { is_set_array, is_set_object } from "$lib/js/helpers";
  import { page } from '$app/state';
  import { PUBLIC_STRAPI_MEDIA } from '$env/static/public';
  import { t } from 'svelte-i18n-lingui';
  import type { BrandBanner } from "$lib/js/strapi/types";
	import { getContextScope } from '$lib/js/helpers/i18n'

  interface Props {
    type?: 'default' | 'product';
  }

  let { type = 'default' }: Props = $props();
  let banner: BrandBanner | undefined = page.data.brands_banner

	const scope = getContextScope()
</script>


{#if banner && is_set_object(banner)}
  <div class="container">
    <div class="brands {type}">
      <div class="brands__inner">
        <div class="brands__title">
          <h2 class="head-3">{banner.title}</h2>
          <a class="u-btn u-btn--web" href="/{scope}/brands">{$t`View all brands`}</a>
        </div>

        <div class="brands__images">
          <Marquee repeat={3} pauseOnHover={true}>
            {#if is_set_array(banner.brand)}
              {#each banner.brand as brand}
                <a href="/{scope}/brands/{brand.link}">
                  <img
                    loading="lazy"
                    src="{PUBLIC_STRAPI_MEDIA}{brand.logo.url}"
                    title="{brand.title}"
                    alt="{brand.title}"
                    height="{brand.logo.height}"
                    width="{brand.logo.width}"
                  />
                </a>
              {/each}
            {/if}
          </Marquee>
        </div>
      </div>
    </div>
  </div>
{/if}


<style lang="scss">
  .brands {
    &.product {
      margin: 0 -20px;

      @media (min-width: 769px) {
        margin-left: -35px;
        margin-right: -35px;
      }

      @media (min-width: 769px) {
        margin-left: -50px;
        margin-right: -50px;
      }
    }

    &__inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 20px;
      padding-bottom: 20px;

      @media (min-width: 769px) {
        flex-direction: row;
        justify-content: space-between;
        padding-top: 40px;
        padding-bottom: 40px;
      }

      h2 {
        font-weight: 700;
        color: #000;
        line-height: 1;
        margin-bottom: 0;
      }
    }

    &__title {
      h2 {
        font-weight: 900;
        margin-bottom: 15px;
      }

      @media (max-width: 768px) {
        display: flex;
        justify-content: space-between;

        h2 {
          margin-bottom: 8px;
        }

        a {
          display: none;
        }
      }
    }

    &__images {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      position: relative;

      @media (min-width: 769px) {
        width: calc(100% - 220px);
      }

      &::before,
      &::after {
        content: "";
        position: absolute;
        pointer-events: none;
        z-index: 1;
        width: 50px;
        height: 100%;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
      }

      &::before {
        left: 0;
        transform: rotate(180deg);
      }

      &::after {
        right: 0;
      }

      a {
        display: flex;
        justify-content: center;
        padding: 0 5px;

        @media (min-width: 769px) {
          padding: 0 15px;
        }

        &:hover {
          img {
            @media (min-width: 769px) {
              transform: scale(1.1);
            }
          }
        }

        img {
          height: auto;
          width: 100%;
          margin: 10px;
          max-width: 100px;
          transition: all linear 0.125s;

          @media (min-width: 769px) {
            max-width: 130px;
          }
        }
      }
    }
  }
</style>
